export const FILE_EXTENTIONS = {
	HTML: '.html',
	PDF: '.pdf',
	SVG: '.svg'
}